
import { supabase } from '@/integrations/supabase/client';
import { getUserSubscription, getPremiumListingsUsage } from '@/lib/actions/subscriptionActions';

// PayPal Client ID
export const PAYPAL_CLIENT_ID = "AcI0j4CzmV0dp16uIo63Hz-c0LuAQipseyumQWQ2eaqxhNEW4b_zl1HIwuRuGF1c47gmXI4ARtKFnpLi";

export const initializePaymentGateway = async () => {
  // Check if PayPal script is already loaded
  if (window.paypal) {
    return;
  }

  return new Promise((resolve, reject) => {
    try {
      // Create PayPal script with client ID
      const script = document.createElement('script');
      script.src = `https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}&currency=EUR`;
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = () => reject(new Error("Failed to load PayPal SDK"));
      
      // Add the script to the document
      document.body.appendChild(script);
    } catch (error) {
      reject(error);
    }
  });
};

// Check if user has free premium listings available from subscription
export const checkFreePremiumListingsAvailable = async (userId: string): Promise<boolean> => {
  try {
    // Get premium listings usage data directly
    const usageData = await getPremiumListingsUsage(userId);
    
    if (!usageData) return false;
    
    // Check if user has a valid subscription and available premium listings
    return usageData.has_subscription && 
           ['pro', 'business'].includes(usageData.plan_id) && 
           usageData.premium_listings_available > 0;
  } catch (error) {
    console.error('Error checking premium listings availability:', error);
    return false;
  }
};

// Use a free premium listing from subscription
export const useFreePremiumListing = async (userId: string, listingId: number): Promise<boolean> => {
  try {
    const { data, error } = await supabase.functions.invoke('use-premium-listing', {
      body: { user_id: userId, listing_id: listingId }
    });
    
    if (error) throw error;
    
    return data?.success || false;
  } catch (error) {
    console.error('Error using free premium listing:', error);
    return false;
  }
};

// Add the missing markListingAsPremium function
export const markListingAsPremium = async (listingId: number): Promise<boolean> => {
  try {
    // Update the listing in the database
    const { error } = await supabase
      .from('listings')
      .update({ is_premium: true })
      .eq('id', listingId);
    
    if (error) {
      console.error('Error marking listing as premium:', error);
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Error in markListingAsPremium:', error);
    return false;
  }
};
